import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services';
import { environment } from '../../../environments/environment';
import { VendorOnboarding } from '../models/vendor-onboarding';

@Injectable({
  providedIn: 'root'
})
export class VendorOnboardingService {
    constructor(private http: HttpClient,
        private apiService: ApiService) { }
        InitiateVendorOnboardProcess(vendorOnboarding:VendorOnboarding):Observable<any>{
            return this.apiService.post(`VendorOnboardProcess/InitiateVendorOnboardProcess`,vendorOnboarding)
        }
        GeneratePOTemplate(vendorOnboarding:VendorOnboarding):Observable<any>{
           // debugger;
            return this.apiService.post(`VendorOnboardProcess/GeneratePOTemplate`,vendorOnboarding)
        }
        GenerateMSATemplate(vendorOnboarding:VendorOnboarding):Observable<any>{
            // debugger;
             return this.apiService.post(`VendorOnboardProcess/GenerateMSATemplate`,vendorOnboarding)
         }
         GenerateNCATemplate(vendorOnboarding:VendorOnboarding):Observable<any>{
            // debugger;
             return this.apiService.post(`VendorOnboardProcess/GenerateNCATemplate`,vendorOnboarding)
         }
         GetVendorOnboardProcess(tempEmailLinkRefId):Observable<any>{
            return this.apiService.get(`VendorOnboardProcess/${tempEmailLinkRefId}`)
        }
        UpdateVendorOnboardProcess(vendorOnboarding:VendorOnboarding):Observable<any>{
            return this.apiService.post(`VendorOnboardProcess/UpdateVendorOnboardProcess`,vendorOnboarding)
        }
        getVendorDetails(vendorId):Observable<any>{
            return this.apiService.get(`VendorOnboardProcess/GetVendorDetails/${vendorId}`)
        }
}